import { initSdks, ingame, getSys } from '@tencent/pa-cms-utils';
import { IsTest, isInIntlBrowser, canUseNavigatorShare } from './tools';
import { isHtm } from './const';
import { game_id } from "@/utils/const";

const shareOrigin = isHtm ? 'https://nikke-en.com' : location.origin.replace('test.', '');
// 分享地址 经 cms 配置产生
export const prodSharePath = `${shareOrigin}/socialshare/share`;
export const tesSharePath = `${shareOrigin}/socialshare/share`;
export const testCampaignId = isHtm ? '168673173229897' : '169087720849913';
export const prodCampaignId = isHtm ? '168673173229897' : '169087720849913';
export const test_cms_game_id = '16';
export const test_cms_area_id = 'na';
export const cms_game_id = '16';
export const cms_area_id = 'na';
export const KAKAO_JS_KEY = 'abfa7acb3ee1b52626406b1833d82a0f';

export const config = {
  cms_config: {
    cms_areaid: IsTest ? test_cms_area_id : cms_area_id,
    cms_gameid: IsTest ? test_cms_game_id : cms_game_id,
    cms_lang:  'en',
    custom_cms_url: 'https://na-community.playerinfinite.com',
  },
  intl_account_config: {
    intl_gameid: game_id,
    intl_account_area_id: IsTest ? 'test' : 'li-sg',
  },
}
function getOpenType() {
  // ios 使用self
  const os = getSys().name;
  if (!os) return '_blank';
  const selfMap = ['macOS', 'iOS'];
  const isSelf = selfMap.find(osName => os.toLowerCase().includes(osName.toLowerCase()));
  if (isSelf) return '_self';
  return '_blank';
}
const openType = getOpenType()
/**
 * @description 危险代码 -> 为了处理游戏内分享crash的问题，采用此代码进行兜底
 */
if (isInIntlBrowser) {
  const open_func_pointer = window.open;

  // @ts-ignore
  window.open = function(url?: string, target?: string, features?: string) {
    console.warn('[warning]:', 'this is an override "window.open" function. due to the crash of built-in browser in game')
    console.log('open', url, target, features)
    if (ingame.isInIntlBrowser) {
      ingame.openInBrowser(url!);
    } else {
      return open_func_pointer(url, target, features);
    }
  }
}
/**
 * danger code ended
 */

const { cms_helper, intl_account_helper } = initSdks(config);

export const dynamicShare = async (options: any) => {
  const { file, uid, url_querys } = options;
  let params = {
    img_file: file,
    uid,
    campaign_id: prodCampaignId,
    share_pre_path: prodSharePath,
    url_querys,
  }
  if (IsTest){
    params = {
      ...params,
      campaign_id: testCampaignId,
      share_pre_path: tesSharePath,
    }
  }
  console.log('params', params)
  const result = await cms_helper.dynamicShare(params)
  return result
}

const kakaoShare = (options: any) => {
  const { share_url, text, title, image_url } = options;
  intl_account_helper?.share({
    third_type: 'kakao',
    shareType: 'talk',
    title,
    text,
    description: text,
    jsKey: KAKAO_JS_KEY,
    href: share_url,
    imageUrl: image_url,
  });
};

const lineShare = (options: any) => {
  const { share_url, text } = options;
  // if (ingame.isInIntlBrowser) {
  //   ingame.intlshare({
  //     channel: InGameChannel.Line,
  //     type: ShareContentType.REQ_LINK,
  //     desc: t('share_text'),
  //     imageType: 0,
  //     link: url_ref.value,
  //     imagePath: image_url_ref.value,
  //   });
  // } else {
  intl_account_helper?.share({
    third_type: 'line',
    text: text + '  ' + share_url,
    windowopen_type: openType,
  });
  // }
};

const twshare = (options:any) => {
  const { share_url, text } = options;
  // if (ingame.isInIntlBrowser) {
  //   ingame.intlshare({
  //     channel: 'System',
  //     desc: t('share_text'),
  //     link: url_ref.value,
  //     type: ShareContentType.REQ_LINK,
  //   });
  // } else {
  intl_account_helper?.share({
    third_type: 'twitter',
    text: text + '  ' + share_url,
    windowopen_type: openType,
  });
  // }
};
const fbshare = async (options: any) => {
  const { channel, share_url, text, hashtag, fb_appid, title } = options;
  const url = encodeURI(share_url)
  
  const fb_share_url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(share_url)}`;
  if (ingame.isInIntlBrowser) {
    // ingame.share({
    //   channel: channel,
    //   type: 10001,
    //   // text: text,
    //   title: title,
    //   desc: text,
    //   imageType: 0,
    //   link: share_url,
    // });
    ingame.openInBrowser(fb_share_url, { window_opentype:  openType });
  } else {
    const params = {
      hashtag,
      app_id: fb_appid,
      href: url,
      quote: text,
      redirect_uri: location.origin.includes('localhost') ? "" : undefined,
    };
    // intl_account_helper?.share({
    //   app_id: fb_app_id,
    //   third_type: 'facebook',
    //   href: url_ref.value,
    //   quote: text,
    // });
    // window.open(fb_share_url, openType);
    const share_params = Object.assign({}, params, {
      third_type: channel,
      windowopen_type:  openType,
    })
    console.log('share_params', share_params)
    await intl_account_helper?.share(share_params);
  }
};

/**
* 分享
* @see aovmatch intlsdk
*/
export const share = async (options:any) => {
  const { channel } = options;
  switch (channel) {
    case 'twitter': {
      return twshare(options);
    }
    case 'facebook': {
      return fbshare(options);
    }
    case 'line': {
      return lineShare(options);
    }
    // case 'kakao': {
    //   return kakaoShare();
    // }
  }
  // if (isInIntlBrowser) {
    // intlShare(options);
  // } else {
  //   webShare(options);
  // }
}

/** @see link https://docs.playernetwork.intlgame.com/docs/zh/samples/INTLWebViewSample.html} */ 
export const intlShare = (options: any) => {
  const { channel, url, text, title, image_url } = options;
  const params = {
    channel,
    type: channel === 'facebook' ? 10001 : 10000, // TODO
    title,
    desc: text,
    imageType: 0,
    imagePath:image_url,
    link: url,
  };
  console.log(options);

  ingame.share(params as any);
}

const webShare = async (options: any) => {
  const { channel, share_url, text, hashtag, fb_appid, title, image_url } = options;
  const url = encodeURI(share_url)
  let params;
  switch (channel) {
    case 'facebook': {
      params = {
        hashtag,
        app_id: fb_appid,
        href: url,
        quote: text,
        redirect_uri: location.origin.includes('localhost') ? "" : undefined,
      };
      break;
    }
    case 'twitter': {
      params = {
        url,
        text,
        hashtags: hashtag,
      };
      break;
    }
    case 'whatsapp':
    case 'line': {
      params = {
        text: `${text} ${url}`,
        url,
        title,
      };
      break;
    }
    case 'kakao': {
      params = {
        shareType: 'talk',
        title,
        text,
        description: text,
        jsKey: KAKAO_JS_KEY,
        href: url,
        imageUrl: image_url,
      }
      break;
    }
    case 'instagram':
    case 'system': {
      if (canUseNavigatorShare(url)) {
        navigator.share({ text: url });
      }
      return;
    }
  }
  const share_params = Object.assign({}, params, {
    third_type: channel,
    // windowopen_type: '_blank',
  })
  console.log('share_params', share_params)
  await intl_account_helper?.share(share_params);
}

